(function () {
    'use strict';

    run.parts.mainNavbar = function() {
        const navbar = document.getElementById('main_navbar');
        const container = document.getElementById('main_navbar_mobile');
        const toggler = document.getElementById('main_navbar_toggler');
        const cover = document.getElementById('main_navbar_cover');
        if (navbar) {
            toggler.addEventListener("click", function()
            {
                navbar.classList.toggle('visible');
                toggler.classList.toggle('active');
                cover.classList.toggle('visible');
            });

            cover.addEventListener("click", function()
            {
                navbar.classList.toggle('visible');
                toggler.classList.toggle('active');
                cover.classList.toggle('visible');
            });

            // Show mobile logo on load and scroll
            function toggleMobileLogoVisibility()
            {
                let scrollPosition = window.scrollY;
    
                if (scrollPosition >= 30) {
                    container.classList.add('scrolled');
                } else {
                    container.classList.remove('scrolled');
                }
            }
    
            toggleMobileLogoVisibility();
    
            window.addEventListener('scroll', toggleMobileLogoVisibility);
        }

    };
})();